<script>
  import Preload from "preload-it"

  import { planets, loading, soundBlobs, progress } from "../js/stores.js"

  const preload = Preload({ stepped: false })

  const urls = [
    // Planets
    "images/planets/neptune.svg",
    "images/planets/uranus.svg",
    "images/planets/jupiter.svg",
    "images/planets/saturn.svg",
    "images/planets/mars.svg",
    "images/planets/moon.svg",
    "images/planets/earth.svg",
    // Sound effects
    "sounds/bubble10.mp3",
    "sounds/correct1.mp3",
    "sounds/hover.mp3",
    "sounds/wrong1.mp3",
    "sounds/wrong2.mp3",
    "sounds/rocket-launch.mp3",
    "sounds/finale.mp3",
  ]
  preload.fetch(urls)

  let progressWorking = false

  preload.onprogress = (event) => {
    progressWorking = true
    // console.log("progress: " + event.progress)
    $progress = event.progress / 100
  }

  preload.oncomplete = (items) => {
    $planets = items.slice(0, 7).map((item) => item.blobUrl)
    $soundBlobs = items.slice(7, 14).map((item) => item.blobUrl)
    // console.log($soundBlobs);
    $loading = false
  }

  let fetched = 0
  preload.onfetched = (item) => {
    fetched++
    if (!progressWorking) $progress = fetched / urls.length
    // This is needed when progress bar is not working (incompatible chromium + firebase combo)
  }
</script>
